export const PDM_REGIONS = ['NAMR', 'EMEA', 'ANZ', 'APAC'] as const;

export type PdmRegion = (typeof PDM_REGIONS)[number];
export const NO_REGION_LABEL = 'No region';

export const PDM_REGION_COLORS: Record<PdmRegion, string> = {
  NAMR: '#D1006C',
  EMEA: '#008272',
  ANZ: '#8764B8',
  APAC: '#0078D4',
};
